var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "LogOut" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from },
        on: { Refresh: _vm.Refresh, search: _vm.search },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.add(false)
                      },
                    },
                  },
                  [_vm._v("新增")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "fullname", align: "center", label: "客户名称" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "member_type_txt",
                  align: "center",
                  label: "客户类型",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logistics_name",
                  align: "center",
                  label: "注销前所在仓",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "mobile",
                  align: "center",
                  label: "注销前客户手机号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "register_time",
                  align: "center",
                  label: "注册时间",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "days", align: "center", label: "注册天数" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logout_time",
                  align: "center",
                  label: "注销时间",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "reason", align: "center", label: "注销原因" },
              }),
              _c("el-table-column", {
                attrs: { prop: "pic", align: "center", label: "注销证明" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.imagelist(scope.row)
                              },
                            },
                          },
                          [_vm._v("点击查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "submit_name",
                  align: "center",
                  label: "操作人",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "op_name", align: "center", label: "审核人" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "audit_time",
                  align: "center",
                  label: "审核时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "black_status_txt",
                  align: "center",
                  label: "注销状态",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "order_no", align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.is_audit && scope.row.audit_status == 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.Cancel(scope.row)
                                  },
                                },
                              },
                              [_vm._v("审核")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.from.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.centerDialogVisible,
            width: "60%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "500px", "overflow-y": "auto" } },
            _vm._l(_vm.delete_info_pic, function (url) {
              return _c("el-image", { key: url, attrs: { src: url } })
            }),
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.centerDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.centerDialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("LogOutadd", { ref: "LogOutaddref", on: { Refresh: _vm.Refresh } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }